var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6012 20.2821V18.4417C16.6012 17.4654 16.2134 16.5292 15.523 15.8389C14.8327 15.1486 13.8965 14.7607 12.9202 14.7607H5.55837C4.58213 14.7607 3.64587 15.1486 2.95556 15.8389C2.26525 16.5292 1.87744 17.4654 1.87744 18.4417V20.2821",
    stroke: "#4F4F4F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2394 11.0799C11.2723 11.0799 12.9203 9.43187 12.9203 7.39895C12.9203 5.36603 11.2723 3.71802 9.2394 3.71802C7.20648 3.71802 5.55847 5.36603 5.55847 7.39895C5.55847 9.43187 7.20648 11.0799 9.2394 11.0799Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1225 20.2821V18.4417C22.1219 17.6261 21.8504 16.8338 21.3507 16.1892C20.8511 15.5446 20.1515 15.0843 19.3618 14.8804",
    stroke: "#4F4F4F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.681 3.83765C16.4728 4.04037 17.1746 4.50086 17.6758 5.1465C18.1769 5.79215 18.4489 6.58622 18.4489 7.40355C18.4489 8.22087 18.1769 9.01495 17.6758 9.66059C17.1746 10.3062 16.4728 10.7667 15.681 10.9694",
    stroke: "#4F4F4F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.a64028425e77e17a388d7febe4e5d3d1.svg";
export { ForwardRef as ReactComponent };